<template>
  <div class="user-register">
    <div class="user-register-wrapper">
      <registerInfo :currentView="currentView" :model="model" v-model="model.UserAccount"></registerInfo>
    </div>
  </div>
</template>
<style scoped>
  .user-register-wrapper {
    padding: 0 0.266rem;
  }

</style>
<script>
  import registerInfo from './register-info.vue'
  export default {
    data() {
      return {
        model: {
          RoleName: '',
          RootID: '',
          RoleType: '',
          UserAccount: {
            UserID: '',
            UserAct: '',
            UserPwd: '',
            ConfirmPwd: '',
            ValidCode: '',
            MobileCode: '',
          },
        }
      }
    },
    props: ['currentView'],
    components: {
      registerInfo
    },
  }

</script>
